<template>
	<transition-group name="notification" class="snack-bar" tag="div" appear>
		<notification
			v-for="(notification, i) in NOTIFICATIONS"
			:key="notification.id"
			:index="i"
			:notification="notification"
		></notification>
	</transition-group>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Notification from "@components/partials/Notification";

export default {
	data() {
		return {};
	},

	components: { Notification },

	computed: {
		...mapGetters({
			NOTIFICATIONS: "notifications"
		})
	}
};
</script>
